
import { sortBy, uniqBy, countBy } from "lodash";
import {
  getAcceptabilityFromProCon,
  getSubOptionById,
  getCriterionById,
  getAimById,
  normalizeByAlternative,
  filterItemsBy,
  c_alternativesIds,
  getAimsCountFromAimsAndCriterion,
  getAimsFromItems,
  state,
} from "@/store";
import { NormalizedArgument } from "@/@types";

import Acceptability from "@/components/Acceptability.vue";
import PropertiesListCriterion from "@/components/PropertiesList/PropertiesListCriterion.vue";
import { computed, defineComponent, ref, toRefs, PropType } from "vue";
export default defineComponent({
  props: {
    items: {
      type: Array as PropType<NormalizedArgument[]>,
      required: true,
    },
    property: {},
  },

  setup(props) {
    const { items, property } = toRefs(props);

    const showDetails = ref(false);

    const criterionItems = computed(() => {
      return uniqBy(items.value, "criterion");
    });
    const aimItems = computed(() => {
      return uniqBy(items.value, "aim");
    });

    const hasMany = computed(() => {
      return criterionItems.value.length > 1 || aimItems.value.length > 1;
    });

    return {
      state,
      c_alternativesIds,
      showDetails,

      criterionItems,
      aimItems,
      hasMany,

      getAimsCountFromAimsAndCriterion,
      getAimsFromItems,
      countBy,
      sortBy,
      getSubOptionById,
      getCriterionById,
      getAimById,
      getAcceptabilityFromProCon,
      normalizeByAlternative,
      filterItemsBy,
      uniqBy,
    };
  },

  // data: () => ({
  //   state,
  //   showDetails: false
  // }),
  // computed: {

  // },
  components: {
    Acceptability,
    PropertiesListCriterion,
  },
  // props: ["items", "property"],
});
